import { h } from '@debbie/cortex/dist/index.js';
import * as workflows from '@debbie/cortex/dist/workflows/index.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { load } from '../connect/utils.js';
import Errors from '../Errors.js';
const WorkflowPreview = (props) => {
    const preview = workflows.useWorkflowById(props.id);
    return (React.createElement("div", null,
        h.isError(preview) ? React.createElement(Errors, { errors: [preview.error.message] }) : null,
        load({ preview }, ({ preview }) => {
            return React.createElement(Link, { to: `/workflows/${props.id}` }, preview.title);
        }, 'loading')));
};
export default WorkflowPreview;
//# sourceMappingURL=WorkflowPreview.js.map